module.exports = __webpack_public_path__ + "img/box6-10.e5c0318d.png";